import React from 'react';
import { ProductPatch, addProduct } from '../../model/product';
import { ModalController } from '../../components/Modal/ControlledModal';
import { TextField } from '../../components/Form/TextField/TextField';
import { t } from '../../locales/translate';
import { Form, useChanges } from '../../components/Form/Form';
import { handleError } from '../../model/notification';
import GlobalProps from '../../components/globalProps';
import { Stack } from '../../components/Stack/Stack';

interface Props extends GlobalProps {
  controller: ModalController<Partial<ProductPatch>>;
}

export function AddProduct({ controller }: Props): JSX.Element {
  const [, , model, trackChanges] = useChanges<Partial<ProductPatch>>({});

  async function handleOnSubmit(): Promise<void> {
    try {
      await addProduct({
        nameDe: model.name,
        colorDe: model.color,
        materialDe: model.material,
        artistDe: model.artist,
        productTypeDe: model.productType,
        shippableFrom: model.publicShippableFrom,
      });
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <Stack>
            <TextField name="artist" label={t.model.artist._name} required />
            <TextField name="name" label={t.general.motive} />
            <TextField name="productType" label={t.general.type} />
            <TextField name="color" label={t.general.color} />
            <TextField name="material" label={t.general.material} />
          </Stack>
        );
      }}
    </Form>
  );
}
